/* NSL — interactions */
(function(){
  'use strict';
  function q(s,r){return (r||document).querySelector(s);}
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

  var toast;
  function showToast(m){ if(!toast){toast=document.createElement('div');toast.className='toast';document.body.appendChild(toast);} toast.textContent=m; toast.setAttribute('data-show',''); clearTimeout(toast._t); toast._t=setTimeout(function(){toast.removeAttribute('data-show');},2800); }

  /* mobile menu */
  function menu(){
    var b=q('.burger'), m=q('.mobile-menu'); if(!b||!m) return;
    b.addEventListener('click',function(){ var o=m.hasAttribute('data-open'); m.toggleAttribute('data-open'); document.body.style.overflow=o?'':'hidden'; b.setAttribute('aria-expanded',String(!o)); });
    qa('a',m).forEach(function(a){a.addEventListener('click',function(){m.removeAttribute('data-open');document.body.style.overflow='';});});
  }

  /* ignition buttons */
  function ignition(){
    qa('.btn-engine').forEach(function(b){ b.addEventListener('click',function(){ b.classList.remove('is-firing'); void b.offsetWidth; b.classList.add('is-firing'); }); });
  }

  /* faq gearshift */
  function faq(){
    qa('.faq-item').forEach(function(it){
      var q1=q('.faq-q',it), a=q('.faq-a',it); if(!q1||!a) return;
      q1.addEventListener('click',function(){
        var open=it.hasAttribute('data-open');
        qa('.faq-item').forEach(function(o){o.removeAttribute('data-open');var oa=q('.faq-a',o);if(oa)oa.style.maxHeight=null;var ob=q('.faq-q',o);if(ob)ob.setAttribute('aria-expanded','false');});
        if(!open){ it.setAttribute('data-open',''); a.style.maxHeight=a.scrollHeight+'px'; q1.setAttribute('aria-expanded','true'); }
      });
    });
  }

  /* inventory filter */
  function filter(){
    var bar=q('[data-filterbar]'); if(!bar) return;
    qa('button',bar).forEach(function(btn){
      btn.addEventListener('click',function(){
        qa('button',bar).forEach(function(x){x.removeAttribute('data-active');}); btn.setAttribute('data-active','');
        var f=btn.dataset.filter;
        qa('.veh').forEach(function(v){ v.style.display=(f==='all'||v.dataset.type===f)?'':'none'; });
      });
    });
  }

  /* vehicle quick-inquiry modal */
  function vehicleModal(){
    var root=q('#veh-modal'); if(!root) return;
    var title=q('#vm-title',root), body=q('#vm-body',root);
    function open(v){
      title.textContent=v.dataset.title||'Vehicle';
      body.innerHTML='<p class="vm-meta">'+(v.dataset.meta||'')+' · <b>'+(v.dataset.type||'')+'</b></p>'+
        '<p class="vm-price">Price on request</p>'+
        '<p>Wholesale pricing for this unit is quoted on request, in USD and below market value, and confirmed in a written purchase agreement. Units are sold as-is. Availability changes daily — contact us for the live list.</p>'+
        '<div class="vm-actions"><a class="btn btn-accent btn-engine" href="/pages/contact">Request this unit</a>'+
        '<a class="btn btn-outline" href="tel:+18434550826">Call +1-843-455-0826</a></div>';
      root.hidden=false; document.body.style.overflow='hidden'; requestAnimationFrame(function(){root.setAttribute('data-open','');});
      ignition();
    }
    function close(){ root.removeAttribute('data-open'); document.body.style.overflow=''; setTimeout(function(){root.hidden=true;},250); }
    qa('.veh[data-title]').forEach(function(v){ v.addEventListener('click',function(e){ if(e.target.closest('a'))return; open(v); }); });
    qa('[data-vm-close]',root).forEach(function(x){x.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!root.hidden)close();});
  }

  /* forms — ignition submit -> toast */
  function forms(){
    qa('form[data-inquiry]').forEach(function(f){
      f.addEventListener('submit',function(e){ e.preventDefault(); showToast('Request sent — we\'ll reply within one business day.'); f.reset(); });
    });
  }

  /* cookie consent */
  function cookie(){
    var el=q('#cookie-consent'); if(!el) return;
    var KEY='nsl_cookie';
    try{ if(!localStorage.getItem(KEY)) el.hidden=false; }catch(e){ el.hidden=false; }
    qa('[data-cookie]',el).forEach(function(b){ b.addEventListener('click',function(){ try{localStorage.setItem(KEY,b.dataset.cookie);}catch(e){} el.hidden=true; }); });
  }

  function init(){ menu(); ignition(); faq(); filter(); vehicleModal(); forms(); cookie(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
